import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import AcuraIcon from './icons/AcuraIcon';
import HondaIcon from './icons/HondaIcon';
const styles = StyleSheet.create({
    text: {
        fontSize: '10px',
        letterSpacing: '0.5px',
        marginLeft: '16px',
    },
    footer: {
        position: 'absolute',
        bottom: '32px',
        left: '40px',
        right: '40px',
    },
    svgImage: {
        width: 44,
        height: 28,
    },
});
const Footer = ({ isVariant }) => {
    const { t } = useTranslation();
    const createdLabel = t('Pages.Bap.createdLabel');
    const date = new Date().toISOString().split('T')[0];
    return (React.createElement(View, { fixed: true, style: styles.footer },
        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' } },
            React.createElement(View, null, isVariant ? React.createElement(AcuraIcon, null) : React.createElement(HondaIcon, null)),
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(Text, { style: styles.text },
                    createdLabel,
                    ": ",
                    date),
                React.createElement(Text, { style: styles.text, render: ({ pageNumber, totalPages }) => ` ${pageNumber}/${totalPages}` })))));
};
export default Footer;
